import { CANONICAL_OPERATIONS_REGISTRY } from '../operations/index.js';
import { PLANNED_OPERATIONS } from '../operations/planned.operations.js';
import { PERMISSION_REGISTRY as DECLARED_PERMISSION_REGISTRY, } from './permission.registry.js';
import { PORTFOLIO_PERFORMANCE_PERMISSION_REGISTRY } from './portfolio-performance-permission.registry.js';
const ALL_DECLARED_PERMISSIONS = Object.freeze({
    ...DECLARED_PERMISSION_REGISTRY,
    ...PORTFOLIO_PERFORMANCE_PERMISSION_REGISTRY,
});
const EFFECTIVE_OPERATION_PERMISSION_IDS = new Set(Object.values(CANONICAL_OPERATIONS_REGISTRY)
    .filter((operation) => operation.implementationStatus !== 'PLANNED' &&
    operation.implementationStatus !== 'UNAVAILABLE')
    .map((operation) => operation.permissionId ?? operation.permission));
/** Permissions referenced only by planned operations are design-time records. */
export const PLANNED_ONLY_PERMISSION_IDS = new Set(Object.values(PLANNED_OPERATIONS)
    .map((operation) => (operation.permissionId ?? operation.permission))
    .filter((permissionId) => !EFFECTIVE_OPERATION_PERMISSION_IDS.has(permissionId)));
function effectivePermission(permissionId, descriptor) {
    if (permissionId === 'organization:market-data:read' ||
        permissionId === 'organization:market-data:manage') {
        return {
            ...descriptor,
            authority: 'ORGANIZATION',
            resourceScope: 'ORGANIZATION',
            description: permissionId === 'organization:market-data:read'
                ? 'Read market data available to the active organization'
                : 'Manage market data under the resolved reference-data authority',
        };
    }
    return descriptor;
}
/**
 * Runtime permission authority. Planned-only permissions are omitted and
 * historical metadata is normalized where deployment-aware authority replaced
 * a permanent platform boundary.
 */
export const EFFECTIVE_PERMISSION_REGISTRY = Object.freeze(Object.fromEntries(Object.entries(ALL_DECLARED_PERMISSIONS)
    .filter(([permissionId]) => !PLANNED_ONLY_PERMISSION_IDS.has(permissionId))
    .map(([permissionId, descriptor]) => [
    permissionId,
    effectivePermission(permissionId, descriptor),
])));
export function isEffectivePermissionId(value) {
    return typeof value === 'string' && value in EFFECTIVE_PERMISSION_REGISTRY;
}
